var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tip-page-box",class:_vm.type == 'gley'
      ? 'gley-box'
      : _vm.type == 'yellow'
      ? 'yellow-box'
      : _vm.type == 'gley-empty'
      ? 'gley-empty-box'
      : ''},[_c('div',{staticClass:"left-icon-box",style:(_vm.type == 'gley-empty' ? 'margin-right:2px' : '')},[(_vm.tipTitle)?_c('span',{staticStyle:{"margin-top":"-2px"}},[_vm._v(_vm._s(_vm.tipTitle))]):[(_vm.type == 'gley' || _vm.type == 'gley-empty')?_c('img',{attrs:{"src":require("@/assets/new-image/tip/gley.svg")}}):(_vm.type == 'yellow')?_c('img',{attrs:{"src":require("@/assets/new-image/tip/yellow.svg")}}):_c('img',{attrs:{"src":require("@/assets/new-image/tip/primary.png")}})]],2),_c('div',{staticClass:"right-tip-box"},[_c('div',[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }